module.exports = __webpack_public_path__ + "img/station-icon.53bb9d6e.svg";